export default {
  exchangeTitle: '换汇',
  accountNumberTitle: '账户',
  exchangeCurrency: '换汇货币',
  exchangeTo: '兑换至',
  exchangeRate: '汇率',
  referenceRate: '参考汇率',

  swapLines: '可兑换金额',
  swapAmount: '兑换金额',
  errorSwapAmount: '请填写正确的换汇金额！',
  inputSwapAmountTips: '请填写换汇金额！',
  selectTradeAccountTips: '请选择交易账户',
  toCurrency: '兑换币种',
  noExchange: '无换汇记录',
  errMsg: {
    '10001': '获取换汇记录失败',
    '10002': '初始化交易账户选项失败'
  },
  tips: {
    '10001': '请输入两位小数点的数字',
    '10002': '兑换金额不得大于可兑换额度'
  },
  exchangeDirection: '兑换方向',
  cashOut: '兑出',
  cashIn: '兑入',
  exchangeAll: '全部兑换',
  lockOut: '锁定兑出金额',
  lockOutTips: '若选择锁定兑出金额，系统将以最终汇率计算出兑入币种之金额。换言之，系统会确保最终兑出之金额为客户输入之数值。兑入币种所得之金额，将会以最终汇率来计算。',
  lockIn: '锁定兑入金额',
  lockInTips: '若选择锁定兑入金额，系统将以最终汇率计算出兑出币种之金额。若可兑换金额足够，系统将确保兑入之金额为客户输入之数值。若因为汇率之浮动引致可兑换金额不足，系统会将可兑换金额全数提取，以兑换成兑入币种之数值。',
  example1: '例一: 可兑换金额足够',
  exampleTip1: '客户之港元可兑换金额为HKD 78,315<br>参考汇率为7.8305港币 = 1美元<br> 客户锁定兑入10,000美元<br> 若最终之汇率与参考汇率一致，则系统计算出之兑出金额为HKD 78,305，客户之港元可兑换金额足够。',
  example2: ' 例二: 可兑换金额不足',
  exampleTip2: '承上例子，若最终汇率变成7.8405港币 = 1美元，则所需兑出金额为HKD 78,405。<br>此时客户之可兑出金额不足，系统将兑出全数HKD 78,315，兑换成USD 9,988.52 ( 78,315 / 7.8405 )。',
  info:
  ` 1. 货币兑换支持7×24小时全天候办理。对于未能实时顺利办理的申请，将由专人于工作日办公时间内跟进处理。 <br/>
    2. 结单显示规则 <br/>
    （以下均为香港时间） <br/>
    <span style="color:#333;font-weight:500;">(I) 证券/基金账户：</span>客户于每日16:59或之前办理完成的货币兑换将反映在当日的结单；其后完成的货币兑换将显示在下一交易日的结单。 <br/>
    <span style="color:#333;font-weight:500;">(II) 期货账户：</span>客户于星期一至五（元旦除外）06:00至翌日05:59期间办理完成的货币兑换将反映在当日的结单；于星期六05:59后办理完成的货币兑换将显示在下一交易日的结单。 <br/>
    备注：若货币兑换于每年元旦当日办理完成，相关记录将显示在下一交易日的结单。 <br/>
    3. 汇率页面仅供参考，实际的兑换汇率会随外汇牌价变化。 <br/>
    4. 若账户内存在未完成结算和交收的资金，有关资金暂不支持兑换。`
}
